import createIcon from '../../createIcon';

/**
 * @component @name SignalWifi4Bar
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIuMDEwNCAyMS4yNEwyMy42NDA0IDYuNzVDMjMuMTkwMyA2LjQxIDE4LjcxMDQgMi43NSAxMi4wMDA0IDIuNzVDNS4yODAzNSAyLjc1IDAuODEwMzUyIDYuNDEgMC4zNjAzNTIgNi43NUwxMS45OTA0IDIxLjI0TDEyLjAwMDQgMjEuMjVMMTIuMDEwNCAyMS4yNFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SignalWifi4Bar = createIcon('SignalWifi4Bar', [
  [
    'path',
    {
      d: 'M12.0104 21.24L23.6404 6.75C23.1903 6.41 18.7104 2.75 12.0004 2.75C5.28035 2.75 0.810352 6.41 0.360352 6.75L11.9904 21.24L12.0004 21.25L12.0104 21.24Z',
      key: 'ovngl',
    },
  ],
]);

export default SignalWifi4Bar;
